/**
 * COURE.HUB.DS.USSD.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type PagePosition = 1 | 2 | 3 | 4 | 5;

export const PagePosition = {
    NUMBER_1: 1 as PagePosition,
    NUMBER_2: 2 as PagePosition,
    NUMBER_3: 3 as PagePosition,
    NUMBER_4: 4 as PagePosition,
    NUMBER_5: 5 as PagePosition
};